<!-- src/App.vue -->
<template>
  <div id="app">
    <Navbar />
    <CircularNav />
    <router-view />
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue';
import CircularNav from './components/CircularNav.vue';

export default {
  name: 'App',
  components: {
    Navbar,
    CircularNav
  },
};
</script>
<style>

@font-face {  
  font-family: "manrope";  
  src: url("@/assets/manr.woff2") format("woff2");  
  font-weight: normal;  
  font-style: normal;  
}

@font-face {
  font-family: "manrope-thin";
  /* src: url("@/assets/WixMadeforText-Regular.ttf") format("truetype"); */
  src: url("@/assets/manrope-thin.otf") format("opentype");
  font-weight:100;
  font-style: normal;
}

body {
  font-family:"manrope";
  margin: 0;
  /* padding: 0; */
  background-color: #2b2c38;
}
</style>